module.exports = __webpack_public_path__ + "img/logo.e2a6b60e.jpg";